import { UpCircleOutlined } from '@ant-design/icons'
import { Component } from 'react'
import { Link } from 'react-router-dom'

export default class BackLink extends Component {
  render() {
    return (
      <Link
        to={this.props.to}
        style={this.props.style}
        className={`btn link ${this.props.className}`}>
          <UpCircleOutlined /> {this.props.children || 'Back'}
      </Link>
    )
  }
}
